module.exports = __webpack_public_path__ + "static/media/logo_letsara_branca_horizontal.8ffd770c.png";